exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:400italic,700italic,300,400,700);", ""]);

// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n\n/* #GOOGLE FONT */\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/alex/Documents/JC/JC3 3/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/alex/Documents/JC/JC3 3/node_modules/postcss-loader?{"ident":"postcss"}!/Users/alex/Documents/JC/JC3 3/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = styles